import { ALL_COMPAIGNS } from "../../constant/ActionType";

export default function AllCompainReducer(
  state = {
    allcompaigns: [],
    statusCode: null,
  },
  action
) {
  switch (action.type) {
    case ALL_COMPAIGNS:
      return {
        ...state,
        allcompaigns: action.data,
        statusCode: action.status,
      };

    default:
  }

  return state;
}
